<script>
import {defineComponent} from 'vue'
import {ElMessage, ElNotification} from "element-plus";
import http from "@/http";

export default defineComponent({
  name: "SchoolInitiativeForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        title: null,
        category_id: null,
        board_id: null,
        student_id: null,
        device_type: 'WEB',
        description: null,
        student_name: null,
        requested_amount: 0,
        color: 'color' + Math.floor(Math.random() * 6),
        photos: [],

        template_id: null,

        school_id: null,
        class_name: null,
        region_id: null,
        district_id: null
      },
      selectedBoard: null,
      baseUrl: process.env.VUE_APP_BASE_API_URL + 'api/v2/info/file/',
      schools: [],
      schoolClasses: [],
      regions: [],
      districts: [],
      categories: [],
      students: [],
      images: [],
      templates: [],

      rules: {
        title: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        region_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        district_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        school_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        class_name: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        student_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        category_id: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        requested_amount: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        student_name: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        description: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
      }
    }
  },
  methods: {
    async uploadImg(event) {
      const file = event.target.files[0];
      try {
        this.loading = true;
        this.form.photos.push(file);
        this.images.push(URL.createObjectURL(file));
      } catch (err) {
        ElNotification.error({
          message:
              err.response.data.message ||
              "Amaliyotni bajarishda xatolik sodir bo'ldi!",
        });
      } finally {
        this.loading = false
      }
    },
    removeSelectedImage(index) {
      this.images.splice(index, 1);
      this.form.photos.splice(index, 1);
    },
    handleImageUpload() {
      const fileInputId = document.getElementById('fileInputRef');
      fileInputId.click()
    },
    onClickRemove() {
      this.form.icon = null
    },

    onChangeSchool() {
      this.form.class_name = null;
      this.form.student_id = null;
      this.getSchoolClasses()
    },
    onChangeClassName() {
      this.form.student_id = null;
      this.getStudents();
    },
    onChangeRegion() {
      this.form.district_id = null;
      this.form.school_id = null;
      this.form.class_name = null;
      this.form.student_id = null;
      this.getDistricts();
    },
    onChangeDistrict() {
      this.form.school_id = null;
      this.form.class_name = null;
      this.form.student_id = null;
      this.getSchools()
    },
    getRegions() {
      this.loading = true;
      this.$http
          .get(`api/v1/regions`)
          .then(({data}) => {
            this.regions = data.regions;
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          }).finally(() => {
        this.loading = false
      });
    },
    getDistricts() {
      this.loading = true;
      this.$http
          .get(`api/v1/districts`, {
            params: {
              region_id: this.form.region_id,
            },
          })
          .then(({data}) => {
            this.districts = data.districts;
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          }).finally(() => {
        this.loading = false;
      });
    },
    getSchools() {
      this.loader = this.loader ? this.loader : true
      this.$http.get(`api/v1/my-school/boards/${this.form.board_id}/schools`,
          {
            params: {
              limit: 10000,
              offset: 0,
              region_id: this.form.region_id,
              district_id: this.form.district_id,

            }
          }
      )
          .then(({data}) => {
            this.schools = data.schools
          })
          .catch((err) => {
            ElNotification({
              title: "Afsus",
              message: err.response.data.message || "Maktablar yuklanmadi",
              type: "error",
            });

          })
          .finally(() => {
            this.loader = false
          })
    },
    getSchoolClasses() {
      this.loader = true
      this.$http.get(`api/v1/my-school/boards/${this.form.board_id}/schools/${this.form.school_id}/classes`,
          {
            params: {
              limit: 10000,
              offset: 0
            }
          })
          .then(({data}) => {
            this.schoolClasses = data.classes
          })
          .catch((err) => {
            ElNotification({
              title: "Afsus",
              message: err.response.data.message || "Maktablar yuklanmadi",
              type: "error",
            });
          })
          .finally(() => {
            this.loader = false
          })
    },
    getSchoolCategories() {
      this.loader = true
      this.$http(`api/v1/my-school/initiative-categories`,
          {
            params: {
              limit: 10000,
              offset: 0
            }
          })
          .then(({data}) => {
            this.categories = data.categories
          })
          .catch((err) => {
            ElNotification({
              title: "Afsus",
              message: err.response.data.message || "Toifalar yuklanmadi",
              type: "error",
            });
          })
          .finally(() => {
            this.loader = false
          })
    },
    getStudents() {
      this.loading = true;
      this.$http
          .get(`api/v1/my-school/students`, {
            params: {
              limit: 1000,
              offset: 0,
              school_id: this.form.school_id,
              class_name: this.form.class_name
            },
          })
          .then(({data}) => {
            this.students = data.students;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getSchoolTemplates() {
      this.loading = true;
      this.$http
          .get(`api/v1/my-school/initiative-templates`, {
            params: {
              limit: 100,
              offset: 0,
            },
          })
          .then(({data}) => {
            this.templates = data.templates;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Shablon yuklanmadi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onSubmit() {

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = !!this.form.photos.length;
          let formData = new FormData();
          if (!this.form.template_id) {
            if (!this.form.photos.length) {
              ElNotification.warning({
                message: "Rasim yuklanmagan!",
              });
              return
            }
            formData.append('title', this.form.title);
            formData.append('category_id', this.form.category_id);
            formData.append('requested_amount', this.form.requested_amount);
            formData.append('description', this.form.description);
            formData.append('board_id', this.form.board_id);
            formData.append('device_type', this.form.device_type);
            formData.append('student_id', this.form.student_id);
            formData.append('student_name', this.form.student_name);
            formData.append('color', this.form.color);

            if (this.form.photos?.length) {
              this.form.photos.forEach(file => {
                formData.append('photos', file);
              })
            }
          } else {
            formData.append('template_id', this.form.template_id);
            formData.append('board_id', this.form.board_id);
            formData.append('student_id', this.form.student_id);
            formData.append('color', this.form.color);
          }

          let http;
          if (this.form.id) {
            http = this.$http.put(`api/v1/my-school/initiatives/with-admin/${this.form.id}`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
          } else {
            http = this.$http.post("api/v1/my-school/initiatives/with-admin", formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    this.getSchoolTemplates();
    this.getRegions();
    this.getSchoolCategories();
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      // this.getCategoryById();
    }
    if (this.$route.query.board && this.$route.query.boardId) {
      this.form.board_id = this.$route.query.boardId;
      this.selectedBoard = this.$route.query.board;
    }
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <h3>{{ selectedBoard }}</h3>
    <br/>
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="Shablonni tanlang" prop="template_id">
                <el-select
                    v-model="form.template_id"
                    style="width: 100%"
                    size="large"
                    clearable
                >
                  <el-option
                      v-for="template in templates"
                      :key="template.id"
                      :value="template.id"
                      :label="template.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="!form.template_id" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item label="Tashabbus nomi" prop="title">
                <el-input size="large" type="text" placeholder="Kiriting" v-model="form.title"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Viloyat" prop="region_id">
                <el-select
                    v-model="form.region_id"
                    style="width: 100%"
                    size="large"
                    @change="onChangeRegion"
                >
                  <el-option
                      v-for="region in regions"
                      :key="region.id"
                      :value="region.id"
                      :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tuman" prop="district_id">
                <el-select
                    v-model="form.district_id"
                    style="width: 100%"
                    size="large"
                    @change="onChangeDistrict"
                >
                  <el-option
                      v-for="district in districts"
                      :key="district.id"
                      :value="district.id"
                      :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Maktabni tanlang" prop="school_id">
                <el-select id="class"
                           name="class"
                           style="width: 100%"
                           size="large"
                           class="mf-select"
                           :aria-required="false"
                           @change="onChangeSchool"
                           v-model="form.school_id">
                  <el-option
                      v-for="school in schools"
                      :key="`selectOptionKey${school.id}`"
                      :value="school.id"
                      :label="school.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Sinf nomi" prop="class_name">
                <el-select id="class"
                           name="class"
                           style="width: 100%"
                           size="large"
                           class="mf-select"
                           :aria-required="false"
                           @change="onChangeClassName"
                           v-model="form.class_name">
                  <el-option
                      v-for="option in schoolClasses"
                      :key="`selectOptionKey${option.class_name}`"
                      :value="option.class_name"
                      :label="option.class_name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="O'quvchini tanlang" prop="student_id">
                <el-select id="class"
                           name="class"
                           style="width: 100%"
                           size="large"
                           class="mf-select"
                           :aria-required="false"
                           v-model="form.student_id">
                  <el-option
                      v-for="student in students"
                      :key="`selectOptionKey${student.id}`"
                      :value="student.id"
                      :label="student.full_name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="!form.template_id" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="O'quvchi ismi" prop="student_name">
                <el-input size="large" type="text" v-model="form.student_name"/>
              </el-form-item>
            </el-col>
            <el-col v-if="!form.template_id" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Toifani tanlang" prop="category_id">
                <el-select id="class"
                           name="class"
                           style="width: 100%"
                           size="large"
                           class="mf-select"
                           :aria-required="false"
                           v-model="form.category_id">
                  <el-option
                      v-for="option in categories"
                      :key="`selectOptionKey${option.title}`"
                      :value="option.id"
                      :label="option.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="!form.template_id" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="So'ralgan pul miqdori" prop="requested_amount">
                <el-input-number type="number" v-model="form.requested_amount" size="large" style="width:100%"/>
              </el-form-item>
            </el-col>
            <el-col v-if="!form.template_id" :span="24">
              <el-form-item label="Izohni kiriting" prop="description">
                <el-input type="textarea" v-model="form.description" rows="5" auto-complete="off"/>
              </el-form-item>
            </el-col>

            <el-col v-if="!form.template_id" :span="24" style="margin-bottom: 20px">
              <el-button size="large" id="upload_img" class="info-btn form-input" @click="handleImageUpload">
                <input type="file" id="fileInputRef" @change="uploadImg" style="display: none"/>
                <img src="@/assets/images/gallery.svg" alt="gallery" style="margin-right: 4px"/>
                Tashabbus fotosuratini yuklang
              </el-button>
            </el-col>
            <div class="gallery-wrapper" v-if="form.photos.length && !form.template_id">
              <div class="images">
                <div class="image-wrapper" v-for="(image,index) in images" :key="index">
                  <img :src="image" alt="gallery"/>
                  <el-button
                      @click.prevent.stop="removeSelectedImage(index)"
                      class="remove-btn">
                    X
                  </el-button>
                </div>
              </div>
            </div>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.gallery-wrapper {
  width: 100%;
  margin-bottom: 20px;
}

.images {
  width: 100%;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.image-wrapper {
  display: block;
  width: calc(100% / 3 - 10px);
  position: relative;

  img {
    border: 2px solid #f1f1f1;
    background-color: #f1f1f1;
    width: 100%;
    height: 100%;
    max-height: 150px;
    object-fit: contain;
  }

  .remove-btn {
    background: #d33b52;
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
